import { render, staticRenderFns } from "./CertificateHorizontal.vue?vue&type=template&id=6360627a&scoped=true"
import script from "./CertificateHorizontal.vue?vue&type=script&lang=js"
export * from "./CertificateHorizontal.vue?vue&type=script&lang=js"
import style0 from "./CertificateHorizontal.vue?vue&type=style&index=0&id=6360627a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6360627a",
  null
  
)

export default component.exports